import { z } from "zod";
import { NotificationEmailCategory } from "@/redux/apis/clientProfile/types";

export const CATEGORIES = [
  {
    key: "default",
    label: "Notification Email",
    description: "This email would be used for all email notifications",
  },
  { key: "booking", label: "Booking Notifications", description: "All booking related alerts" },
  { key: "payment", label: "Payment Notifications", description: "All receipts and payment related alerts" },
  { key: "account", label: "Account Notifications", description: "All account related alerts" },
  { key: "promotions", label: "RideMinder promotions", description: "All RideMinder related alerts" },
] as const;

// Allow a valid email OR an empty string ("" means "not set").
const optionalEmail = z.union([z.literal(""), z.string().email("Email address is not valid")]);

// Primary and secondary are independent: a secondary is always usable — it combines with the
// category's own primary or, when there is none, the inherited default Notification Email. So there
// is no longer a cross-field "secondary requires a primary" rule.
const categorySchema = z.object({
  primary: optionalEmail,
  secondary: optionalEmail,
});

export const emailNotificationsSchema = z.object(
  CATEGORIES.reduce((acc, { key }) => {
    acc[key] = categorySchema;
    return acc;
  }, {} as Record<NotificationEmailCategory, typeof categorySchema>)
);

export type EmailNotificationsFormData = z.infer<typeof emailNotificationsSchema>;
